// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  CustomFieldDefinition,
  type CustomFieldDefinitionWireFormat,
  NewCustomFieldDefinition,
} from '../CustomFieldDefinition/CustomFieldDefinition';

export class ProjectCustomField {
  readonly definition: CustomFieldDefinition;
  readonly value: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.definition = NewCustomFieldDefinition(data.definition);
    this.value = data.value === undefined ? null : data.value;
  }

  static zero(): ProjectCustomField {
    const zeroValues: ExcludeMethodsDeep<ProjectCustomField> = {
      definition: CustomFieldDefinition.zero(),
      value: null,
    };
    return new ProjectCustomField(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectCustomFieldWireFormat = {
  definition: CustomFieldDefinitionWireFormat;
  value: string | null;
};

type NewProjectCustomFieldProps = PartialDeep<ProjectCustomField, { recurseIntoArrays: true }>;
export const NewProjectCustomField: (props: NewProjectCustomFieldProps) => ProjectCustomField = (
  props,
) => new ProjectCustomField(props);

type NewProjectCustomFieldFromWireFormatProps = PartialDeep<
  ProjectCustomFieldWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectCustomFieldFromWireFormat: (
  props: NewProjectCustomFieldFromWireFormatProps,
) => ProjectCustomField = (props) => new ProjectCustomField(props);
